import React, {Component} from "react";
import {Column} from "primereact/column";
import QueryPanel from "../../../../components/query/QueryPanel";
import ResultTable from "../../../../components/query/ResultTable";
import CriteriaPanel from "../../../../components/query/CriteriaPanel";
import {DateInput, FileUploader, NumberInput, SelectInput, TextInput} from "../../../../components";
import DateUtil from "../../../../utils/DateUtil";
import VisitCostingStatus from "./CostSubmissionStatus";
import CostSubmissionStatus from "./CostSubmissionStatus";
import Tooltip from "../../../../components/tooltip/Tooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Modal from "../../../../components/modal/Modal";
import NotificationService from "../../../../services/notification-service/NotificationService";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import FileUtil from "../../../../utils/FileUtil";
import GreenSwitchWithMessage from "../../../../components/switch/GreenSwitchWithMessage";
import ParameterService from "../../../../services/parameter/ParameterService";
import confirmDialog from "../../../../components/dialog/ConfirmDialog";
import confirmAndDeleteDialog from "../../../../components/dialog/ConfirmAndDeleteDialog";
import "./CostSubmission.css";

const initialQueryOptions = {
    visitId: "",
    mrn: "",
    eid: "",
    status: null,
    startDate: DateUtil.addYears(DateUtil.startOfYear(), -1),
    endDate: DateUtil.startOfYear()
};

export default class CostSubmission extends Component {

    constructor(props) {
        super(props);
        this.state = {
            queryOptions: {
                ...initialQueryOptions
            },
            xmlUploadModalVisible: false,
            selectedVisit: null,
            xmlFile: null,
            generateXmlJobOn: false,
            submitXmlJobOn: false
        }
    }

    componentDidMount() {
        ParameterService.getParameter('COST_XML_GENERATION_ENABLED', val => this.setState({generateXmlJobOn: val}));
        ParameterService.getParameter('COST_XML_SUBMISSION_ENABLED', val => this.setState({submitXmlJobOn: val}));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.selected && this.props.selected) {
            this.costSubmissionQueryPanel.query();
        }
    }

    clearQueryOptions = () => {
        this.setState({
            selectedTpa: null,
            insuranceCompanies: [],
            selectedInsuranceCompany: null,
            queryOptions: {...initialQueryOptions}
        });
    }

    downloadXML = (visitCost) => {
        RemotingService.getRemoteCall(`/api/visit-costs/${visitCost.visitId}/xml`, null, (xmlText) => {
            FileUtil.saveAs('Visit-Cost_' + visitCost.visitId, xmlText, FileUtil.FileType.XML);
        });
    }

    confirmDeleteXML = (visitCost) => {
        if (visitCost.status === 'SUBMITTED' || visitCost.status === 'RESUBMITTED') {
            confirmAndDeleteDialog("Delete XML",
                `Are you sure to delete the xml for visit ${visitCost.visitId} because it is already ${visitCost.status} ?`,
                `/api/visit-costs/${visitCost.visitId}`,
                () => { this.costSubmissionQueryPanel.resetAndQuery(); });
        } else {
            this.deleteXML(visitCost);
        }
    }

    deleteXML = (visitCost) => {
        RemotingService.deleteRemoteCall(`/api/visit-costs/${visitCost.visitId}`, null,
            () => { this.costSubmissionQueryPanel.resetAndQuery(); });
    }

    confirmUploadXML = (visitCost) => {
        if (visitCost.status === 'SUBMITTED' || visitCost.status === 'RESUBMITTED') {
            confirmDialog("Delete XML",
                `Are you sure to overwrite the xml for visit ${visitCost.visitId} because it is already ${visitCost.status} ?`, () => {
                    this.uploadXML(visitCost);
                });
        } else {
            this.uploadXML(visitCost);
        }
    }

    uploadXML = (visitCost) => {
        this.setState({
            xmlUploadModalVisible: true,
            selectedVisit: visitCost,
            xmlFile: null
        });
    }

    submitCost = (visitCost) => {
        RemotingService.postRemoteCall(`/api/visit-costs/${visitCost.visitId}`, null,
            (xmlText) => this.costSubmissionQueryPanel.resetAndQuery(),
            () => this.costSubmissionQueryPanel.resetAndQuery());
    }

    statusTemplate(visitCost) {
        const statusName = VisitCostingStatus[visitCost.status]?.name;
        if (visitCost.status === 'REJECTED') {
            return (
                <Tooltip title={visitCost.rejectReason}>
                    <span className="rejected-status">{statusName}</span>
                </Tooltip>
            );
        }
        return statusName;
    }

    actionsTemplate = (cost) => {
        return (
            <div className="d-flex p-justify-center">
                {cost.status !== 'NOT_GENERATED' &&
                    <Tooltip title="Download XML">
                        <FontAwesomeIcon icon="file-download" size="sm" className="ml-1"
                                         onClick={() => this.downloadXML(cost)}/>
                    </Tooltip>
                }
                <Tooltip title="Upload XML">
                    <FontAwesomeIcon icon="file-upload" size="sm" className="ml-1"
                                     onClick={() => this.confirmUploadXML(cost)}/>
                </Tooltip>
                {(cost.status !== 'NOT_GENERATED') &&
                    <>
                        <Tooltip title="Delete XML">
                            <FontAwesomeIcon icon={["fas", "trash"]} size="sm" className="ml-1"
                                             onClick={() => this.confirmDeleteXML(cost)}/>
                        </Tooltip>
                    <Tooltip title="Submit">
                        <FontAwesomeIcon icon="paper-plane" size="sm" className="ml-1"
                                         onClick={() => this.submitCost(cost)}/>
                    </Tooltip>
                    </>
                }
            </div>
        )
    }

    handleUploadXML = () => {
        if (!this.state.xmlFile) {
            NotificationService.showNotification({
                severity: 'warn',
                summary: 'No File Selected',
                detail: 'Please select an XML file to upload.'
            });
            return;
        }

        RemotingService.putRemoteCall(`/api/visit-costs/${this.state.selectedVisit.visitId}/xml`, this.state.xmlFile, () => {
            this.hideXmlUploadModal();
            this.costSubmissionQueryPanel.query();
        });
    }

    hideXmlUploadModal = () => {
        this.setState({
            xmlUploadModalVisible: false,
            selectedVisit: null,
            xmlFile: null
        });
    }

    renderXmlUploadModal = () => {
        return this.state.xmlUploadModalVisible ?
            <Modal visible={this.state.xmlUploadModalVisible}
                   header={'Upload XML'}
                   submitContent="Upload"
                   submitAction={() => this.handleUploadXML()}
                   closeAction={() => this.hideXmlUploadModal()}>
                <div className="container">
                    <div className="row mb-3">
                        <div className="col-12">
                            <p>Please select an XML file to upload:</p>
                            <FileUploader basic accept=".xml" base64={false} maxFileSize={8192}
                                          value={this.state.xmlFile?.content && this.state.xmlFile}
                                          onChange={(file) => {
                                              this.setState({xmlFile: file});
                                          }}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
            : null;
    }

    toggleGenerateXMLJob = () => {
        confirmDialog("Toggling Generate XML Job",
            `Cost xml auto generation will be turned ${(this.state.generateXmlJobOn ? 'off' : 'on')}. Are you sure?`, () => {
                RemotingService.postRemoteCall("/api/visit-costs/jobs/generation", null, () => {
                    this.setState({generateXmlJobOn: !this.state.generateXmlJobOn});
                    NotificationService.showNotification({
                        severity: 'success',
                        summary: 'XML generation job toggled',
                        detail: 'XML generation job is now ' + (this.state.generateXmlJobOn ? 'On' : 'Off')
                    });
                });
            });
    }

    toggleSubmitXMLJob = () => {
        confirmDialog("Toggling Submit XML Job",
            `Cost xml auto submission will be turned ${(this.state.submitXmlJobOn ? 'off' : 'on')}. Are you sure?`, () => {
                RemotingService.postRemoteCall("/api/visit-costs/jobs/submission", null, () => {
                    this.setState({submitXmlJobOn: !this.state.submitXmlJobOn});
                    NotificationService.showNotification({
                        severity: 'success',
                        summary: 'XML submission job toggled',
                        detail: 'XML submission job is now ' + (this.state.submitXmlJobOn ? 'On' : 'Off')
                    });
                });
            });
    }

    render() {
        return (
            <div>
                {this.renderXmlUploadModal()}
                <div className="row">
                    <div className="col-2">
                        <GreenSwitchWithMessage
                            message="Generate XMLs"
                            checked={this.state.generateXmlJobOn}
                            onChange={this.toggleGenerateXMLJob}/>
                    </div>
                    <div className="col-2">
                        <GreenSwitchWithMessage
                            message="Submit XMLs"
                            checked={this.state.submitXmlJobOn}
                            onChange={this.toggleSubmitXMLJob}/>
                    </div>
                </div>
                <QueryPanel ref={el => this.costSubmissionQueryPanel = el}
                            noQueryOnMount
                            url="api/visit-costs"
                            queryOptions={this.state.queryOptions}
                            defaultSize={25}
                            onClear={this.clearQueryOptions}>
                    <CriteriaPanel>
                        <div className="container text-left w-100 ml-0" style={{maxWidth: "inherit"}}>
                            <div className="row">
                                <div className="col-1">Visit Date Between</div>
                                <div className="col-2">
                                    <DateInput className="w-50" utcTime={false}
                                               maxDate={this.state.queryOptions.endDate}
                                               value={this.state.queryOptions.startDate}
                                               onChange={date =>
                                                   this.setState((state) => {
                                                       let newState = {...state};
                                                       newState.queryOptions.startDate = DateUtil.startOfDay(date);
                                                       return newState;
                                                   })
                                               }/>
                                    <DateInput className="w-50" utcTime={false}
                                               minDate={this.state.queryOptions.startDate}
                                               value={this.state.queryOptions.endDate}
                                               onChange={date =>
                                                   this.setState((state) => {
                                                       let newState = {...state};
                                                       newState.queryOptions.endDate = DateUtil.endOfDay(date);
                                                       return newState;
                                                   })
                                               }/>
                                </div>
                                <div className="col-1">Visit Id</div>
                                <div className="col-1">
                                    <NumberInput className="w-100"
                                                 value={this.state.queryOptions.visitId}
                                                 onChange={value =>
                                                     this.setState((state) => {
                                                         let newState = {...state};
                                                         newState.queryOptions.visitId = value;
                                                         return newState;
                                                     })
                                                 }/>
                                </div>
                                <div className="col-1">Status</div>
                                <div className="col-1">
                                    <SelectInput className="w-100" options={CostSubmissionStatus.values()}
                                                 displayProperty="name" valueProperty="key" searchEnabled={false}
                                                 value={this.state.queryOptions.status}
                                                 onChange={value =>
                                                     this.setState((state) => {
                                                         let newState = {...state};
                                                         newState.queryOptions.status = value;
                                                         return newState;
                                                     })
                                                 }/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-1">Patient Document Id</div>
                                <div className="col-2">
                                    <TextInput className="w-100"
                                               value={this.state.queryOptions.eid}
                                               onChange={value =>
                                                   this.setState((state) => {
                                                       let newState = {...state};
                                                       newState.queryOptions.eid = value;
                                                       return newState;
                                                   })
                                               }/>
                                </div>
                                <div className="col-1">Patient MRN</div>
                                <div className="col-1">
                                    <TextInput className="w-100"
                                               value={this.state.queryOptions.mrn}
                                               onChange={value =>
                                                   this.setState((state) => {
                                                       let newState = {...state};
                                                       newState.queryOptions.mrn = value;
                                                       return newState;
                                                   })
                                               }/>
                                </div>
                            </div>
                        </div>
                    </CriteriaPanel>
                    <ResultTable scrollable responsive>
                        <Column field="visitDate" header="Visit Date" style={{width: 180, textAlign: "center"}}
                                body={(cost) => DateUtil.formatDate(cost.visitDate, "DD MMM YYYY")}/>
                        <Column field="visitId" header="Visit Id" style={{width: 140, textAlign: "center"}}/>
                        <Column field="patientMrn" header="Patient MRN" style={{width: 140, textAlign: "center"}}/>
                        <Column field="patientName" header="Patient Name"/>
                        <Column field="patientEid" header="Patient Eid"/>
                        <Column field="providerName" header="Provider"/>
                        <Column field="status" header="Status" style={{width: 140, textAlign: "center"}}
                                body={cost => this.statusTemplate(cost)}/>
                        <Column field="xmlCreatedAt" header="XML Created At" style={{width: 180, textAlign: "center"}}
                                body={(cost) => DateUtil.formatDate(cost.xmlCreatedAt, "DD MMM YYYY HH:mm:ss")}/>
                        <Column field="updatedAt" header="Last Updated At" style={{width: 180, textAlign: "center"}}
                                body={(cost) => DateUtil.formatDate(cost.updatedAt, "DD MMM YYYY HH:mm:ss")}/>
                        <Column header="Actions" body={this.actionsTemplate}
                                style={{width: 70, textAlign: "center"}}/>
                    </ResultTable>
                </QueryPanel>
            </div>
        )
    }

}